import React, { PropTypes } from 'react';
import ReduxToastr from 'react-redux-toastr';
import { Spinner } from 'react-redux-spinner';
import TopBannerContainer from './topBanner/TopBannerContainer.jsx';
import AuthenticationContainer from './auth/AuthenticationContainer.jsx';

const App = ({
  children
}) => (
  <div>
    <Spinner />
    <TopBannerContainer />
    <AuthenticationContainer>
      <div className="container">
        {children}
      </div>
    </AuthenticationContainer>
    <ReduxToastr />
    <iframe id="ifmContentsToPrint"
      style={{ height: 0, width: 0, position: 'fixed', left: '-10px' }}
    />
  </div>
);

App.propTypes = {
  children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/features/shared/App.jsx